
import React, { useState } from "react";
import { Menu } from "lucide-react";
import Sidebar from "./Sidebar";
import GestionarUsuarios from "./GestionarUsuarios";
import GestionarCitas from "./GestionarCitas";
import GestionarHorarios from "./GestionarHorarios";
import GestionarServicios from "./GestionarServicios";
import GestionarGrados from "./GestionarGrados";
import ColorFondoAdmin from "./ColorFondoAdmin";
import GestionarEtiquetasDocentes from "./GestionarEtiquetasDocentes";
import ColorFondoServiciosAdmin from "./ColorFondoServiciosAdmin"; // NUEVO TAB
import GestionarConfiguracionesHorarios from "./GestionarConfiguracionesHorarios";
import GestionarColoresSitio from "./GestionarColoresSitio";
import GestionarResumenCitas from "./GestionarResumenCitas";
import GestionarRespaldos from "./GestionarRespaldos";
import GestionarTemas from "./GestionarTemas";
import GestionarModoSeguridad from "./GestionarModoSeguridad";
import GestionarTituloLogin from "./GestionarTituloLogin";
import EstadisticasCDA from "./EstadisticasCDA";

function AdminPanel({ usuario, onLogout, setColorFondoGlobal, colorSidebar = "#2563eb" }) {
  const [currentTab, setCurrentTab] = useState("usuarios");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const renderContent = () => {
    switch (currentTab) {
      case "usuarios":
        return <GestionarUsuarios />;
      case "citas":
        return <GestionarCitas />;
      case "estadisticasCDA":
        return <EstadisticasCDA />;
      case "horarios":
        return <GestionarHorarios />;
      case "servicios":
        return <GestionarServicios />;
      case "grados":
        return <GestionarGrados />;
      case "temas":
        return <GestionarTemas setColorFondoGlobal={setColorFondoGlobal} />;
      case "colorFondo":
        return <ColorFondoAdmin setColorFondoGlobal={setColorFondoGlobal} />;
      case "colorServicios": // NUEVO TAB
        return <ColorFondoServiciosAdmin />;
      case "coloresSitio":
        return <GestionarColoresSitio />;
      case "etiquetasDocentes":
        return <GestionarEtiquetasDocentes />;
      case "configuracionesHorarios":
        return <GestionarConfiguracionesHorarios />;
      case "resumenCitas":
        return <GestionarResumenCitas />;
      case "respaldos":
        return <GestionarRespaldos />;
      case "modoSeguridad":
        return <GestionarModoSeguridad />;
      case "tituloLogin":
        return <GestionarTituloLogin />;
      default:
        return <GestionarUsuarios />;
    }
  };

  return (
    <div className="flex h-screen">
      <Sidebar
        currentTab={currentTab}
        onTabChange={setCurrentTab}
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        colorSidebar={colorSidebar}
      />

      <div className="flex-1 p-4 md:p-6 overflow-y-auto relative">
        {/* Header */}
        <div className="admin-header flex justify-between items-center mb-6 gap-3">
          <div className="admin-header-info flex items-center gap-3" style={{ minWidth: 0 }}>
            <button
              onClick={() => setSidebarOpen(true)}
              className="admin-header-menu-btn md:hidden text-white p-2 rounded-lg shadow"
              style={{ backgroundColor: colorSidebar, flexShrink: 0 }}
            >
              <Menu size={22} />
            </button>

            <div style={{ minWidth: 0, overflow: "hidden" }}>
              <h2 className="admin-header-title text-xl md:text-3xl font-bold text-white" style={{ whiteSpace: "nowrap" }}>
                Panel de Administración
              </h2>
              <p
                className="admin-header-sub text-sm md:text-base"
                style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", color: "#ffffff" }}
              >
                Bienvenido,{" "}
                <span className="font-semibold">{usuario?.nombre}</span> ({usuario?.role})
              </p>
            </div>
          </div>

          <button
            onClick={onLogout}
            className="admin-header-logout bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg shadow-md text-sm font-semibold transition"
            style={{ flexShrink: 0, whiteSpace: "nowrap" }}
          >
            Cerrar Sesión
          </button>
        </div>

        {/* Saludo aparte, solo en celular — en el header no cabe junto
            al botón "Cerrar Sesión" */}
        <p className="admin-mobile-greeting text-sm" style={{ color: "#ffffff" }}>
          Bienvenido, <span className="font-semibold">{usuario?.nombre}</span> ({usuario?.role})
        </p>

        <style>
          {`
            .admin-mobile-greeting {
              display: none;
              margin: -20px 0 16px;
            }
            @media (max-width: 480px) {
              .admin-header-title {
                font-size: 15px !important;
              }
              .admin-header-sub {
                display: none !important;
              }
              .admin-mobile-greeting {
                display: block !important;
              }
              .admin-header-logout {
                padding: 6px 12px !important;
                font-size: 12px !important;
              }
            }
          `}
        </style>

        {/* Contenido principal */}
        <div className="bg-white rounded-2xl shadow-xl p-3 md:p-6">
          {renderContent()}
        </div>
      </div>
    </div>
  );
}

export default AdminPanel;